/**
 * Internal dependencies
 */
import cecSdk from 'lib/customer-ec-sdk';
import * as actions from 'state/action-types';
import receiveConnectionRetailerPayTypes from './receive-connection-retailer-pay-types';

export default (connectionId) => (dispatch) => {
    dispatch({
        type: actions.CONNECTION_RETAILER_PAY_TYPES_REQUEST,
    });

    return cecSdk
        .connectionRetailerPayTypes(connectionId)
        .getConnectionRetailerPayTypes()
        .then((retailerPayTypes) => {
            dispatch({
                type: actions.CONNECTION_RETAILER_PAY_TYPES_REQUEST_SUCCESS,
            });
            
            dispatch(receiveConnectionRetailerPayTypes(retailerPayTypes));
            return retailerPayTypes;
        })
        .catch((e) => {
            dispatch({ type: actions.CONNECTION_RETAILER_PAY_TYPES_REQUEST_FAILURE, error: e.message });
            throw e;
        });
};
